import Vue from 'vue';
import ToolTipPanel from 'components/widgets/ToolTipPanel/ToolTipPanel.vue';
import ChartToolTipBody from 'components/widgets/ChartToolTipBody/ChartToolTipBody.vue';
const DataToolTip = Vue.extend({
    components: { ToolTipPanel, ChartToolTipBody },
    props: {
        title: { type: String, required: false, default: null },
        action: { type: String, required: false, default: null },
        data: { type: Array, required: false, default: () => [] }
    }
});
export default DataToolTip;
